// sendEmail.js
export const sendEmail = async ({
  from,
  to,
  subject,
  message,
  isHtml = true,
  cc = [],
  bcc = [],
}) => {
  try {
    const apiKey = process.env.REACT_APP_EMAIL_API_KEY;

    if (!apiKey) {
      console.error("Email API key is missing!");
      return { success: false, error: "Missing API key" };
    }

    console.log(apiKey);

    // Build payload
    const payload = {
      from,
      to: Array.isArray(to) ? to : [to], // ensure array
      subject,
      message,
      isHtml,
      cc,
      bcc,
    };

    const response = await fetch(
      "https://helpdesk.greenwellsenergies.co.ke/api/mail/send",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey, // include API key
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(errText || "Failed to send email");
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error sending email:", error);
    return { success: false, error: error.message };
  }
};
